import { createTheme } from "@mantine/core";

export const theme = createTheme({
  colors: {
    brandBlack: [
      "#000000",
      "#000000",
      "#000000",
      "#000000",
      "#000000",
      "#000000",
      "#000000",
      "#000000",
      "#000000",
      "#000000",
    ],
    brandBlue: [
      "rgba(32, 122, 198, 0.2)",
      "#2169A7",
      "#0F71C5",
      "#003E69",
      "#061929",
      "",
      "",
      "",
      "",
      "",
    ],
    brandDarkBlue: [
      "#061929",
      "#061929",
      "#061929",
      "#061929",
      "#061929",
      "#061929",
      "#061929",
      "#061929",
      "#061929",
      "#061929",
    ],
    brandGold: ["#DBB451", "", "", "", "", "", "", "", "", ""],
    brandGray: ["#505050", "#606060", "#EBEBEB", "#F9FAFB", "", "", "", "", "", ""],
  } as any,
});
